import { BankDto } from '@treasury/domain/shared/types';
import { WireIsoLabels } from '@treasury/domain/wires';
import { FieldType, string } from '@treasury/FDL';
import { FdlFieldDefinitions } from '@treasury/FDL/record';

export function createBankFieldDefinitions(
    bankIdLabel: string,
    wireIsoLabels: WireIsoLabels
): FdlFieldDefinitions<BankDto> {
    return {
        bankId: string.with.label(bankIdLabel).thatIs.readOnly() as unknown as FieldType<number>,
        name: string.with.label(`${wireIsoLabels.agent} Name`).thatIs.readOnly(),
        notes: string.with.label('Notes').thatIs.readOnly(),
        addressLine1: string.with.label('Address Line 1').thatIs.readOnly(),
        addressLine2: string.with.label('Address Line 2').thatIs.readOnly(),
        addressLine3: string.with.label('Address Line 3').thatIs.readOnly(),
        city: string.with.label('City').thatIs.readOnly(),
        state: string.with.label('State').thatIs.readOnly(),
        postalCode: string.with.label('Zip').thatIs.readOnly(),
        country: string.with.label(`${wireIsoLabels.agent} Country`).thatIs.readOnly(),
        countryCode: string.with.label(`${wireIsoLabels.agent} Country`).thatIs.readOnly(),
        buildingNumber: string.with.label('Building Number').thatIs.readOnly(),
        streetName: string.with.label('Street Name').thatIs.readOnly(),
        department: string.with.label('Department').thatIs.readOnly(),
        subDepartment: string.with.label('Sub Department').thatIs.readOnly(),
        postBox: string.with.label('Post Box').thatIs.readOnly(),
        buildingName: string.with.label('Building Name').thatIs.readOnly(),
    };
}
